import i18n from '../../../i18n/i18next'
import { Paths } from '../../../routes'
import { useBoundStore } from '../../../state/bound.store'
import { activeNavBar } from '../navBar'
import { NavBarItem } from './navBarItem'
export const TeamNavBarItem = () => {
    const teamPageEnabled = useBoundStore((s) => s.teamPageEnabled)
    return (
        <NavBarItem
            order={2}
            id="navbarItemTeam"
            label={i18n.t('navbar.team')}
            active={activeNavBar.value === 3}
            path={Paths.team}
            icon={'Users'}
            disabled={!teamPageEnabled}
        />
    )
}
